import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router';

import { Grid } from 'components/grid';
import { Loader } from 'components/loader';
import { USER_ROLE } from 'configs/constants';
import Compare from 'helpers/Compare';
import isEmpty from 'lodash/isEmpty';
import ContentBasePage from 'modules/content/components/ContentBasePage';
import MembershipService from 'modules/membership/MembershipService';
import { UiService } from 'modules/ui';
import { UserManagerService } from 'modules/userManager';
import {
  ConcludedContent,
  NotConcludedContent,
  UserDetailHistory
} from 'modules/userManager/userDetail/ContentDetails';
import UserDetailService from 'modules/userManager/userDetail/UserDetailService';
import PropTypes from 'prop-types';

import UserDetailData from './UserDetailData';
import UserDetailHeader from './UserDetailHeader';
import UserDetailQuiz from './UserDetailQuiz';

export const USER_EDIT_TITLE = 'users_manager.users_detail.title';

@withRouter
export default class UserDetail extends Component {
  static propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.shape({
      params: PropTypes.shape({
        userId: PropTypes.string
      })
    }),
    t: PropTypes.func
  };

  state = {
    userData: {},
    notCompletedContents: [],
    completedContents: [],
    loading: true
  };

  setLoading = (loading = false) => this.setState({ loading });

  componentDidMount() {
    document.body.style.overflow = 'hidden';
    document.body.style.overflowY = 'visible';

    if (this.props.match) {
      const { params } = this.props.match;

      this.saveUserData(params.userId);

      this.getContentData(params.userId);
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = 'visible';
  }

  saveUserData(userId) {
    UserManagerService.getUser(userId).then((userData) => {
      const newUserData = { ...userData };

      if (newUserData.userRole === USER_ROLE.FREE_STUDENT) {
        newUserData.userRole = USER_ROLE.STUDENT;
      }

      this.setState({ userData: newUserData });
    });
  }

  getContentData(userId) {
    if (userId) {
      UserManagerService.getContentList(userId)
        .then((data) => {
          const { completedContents, notCompletedContents } = data;
          const completedContentsFormated =
            UserDetailService.formatData(completedContents);

          this.setState({
            completedContents: completedContentsFormated,
            notCompletedContents
          });
          this.setLoading(false);
        })
        .catch((error) => {
          UiService.handleError(error);
          this.setLoading(false);
        });
    }
  }

  renderHeaderData() {
    const { userData = {} } = this.state;

    if (isEmpty(userData)) {
      return null;
    }

    return (
      <Grid block>
        <UserDetailHeader userData={userData} />
        <UserDetailData userData={userData} />
      </Grid>
    );
  }

  renderContentList() {
    const { completedContents = [], notCompletedContents = [] } = this.state;

    return (
      <Fragment>
        {completedContents && (
          <ConcludedContent
            defaultSortName="moduleName"
            defaultOrderBy={Compare.ORDER_BY.ASC}
            content={completedContents}
          />
        )}

        {notCompletedContents && (
          <NotConcludedContent
            defaultSortName="moduleName"
            defaultOrderBy={Compare.ORDER_BY.ASC}
            content={notCompletedContents}
          />
        )}
      </Fragment>
    );
  }

  renderDetailQuiz() {
    return (
      <Grid block>
        <UserDetailQuiz location={this.props.location} />
      </Grid>
    );
  }

  renderDetailHistory() {
    const { userData = {} } = this.state;

    if (isEmpty(userData)) {
      return null;
    }

    return <UserDetailHistory userData={userData} />;
  }

  redirectUser = () => {
    const { history } = this.props;
    const lastPageIsInternal = document.referrer !== '';

    if (lastPageIsInternal) {
      history.goBack();
    } else {
      history.push(MembershipService.getLink('userManager'));
    }
  };

  render() {
    const { loading } = this.state;

    return (
      <ContentBasePage
        classname="content__grid"
        backHandler={this.redirectUser}
      >
        <ContentBasePage.Header title={USER_EDIT_TITLE} />

        {loading ? (
          <Loader key="loader" fixed />
        ) : (
          <Fragment>
            {this.renderHeaderData()}
            {this.renderContentList()}
            {this.renderDetailQuiz()}
            {this.renderDetailHistory()}
          </Fragment>
        )}
      </ContentBasePage>
    );
  }
}
